import { render, staticRenderFns } from "./editor-help.vue?vue&type=template&id=6f71350d"
import script from "./editor-help.vue?vue&type=script&lang=js"
export * from "./editor-help.vue?vue&type=script&lang=js"
import style0 from "./editor-help.vue?vue&type=style&index=0&id=6f71350d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports